import { TextInput } from '@mantine/core';
import { useFocusWithin } from '@mantine/hooks';
import cx from 'clsx';
import { FC, memo } from 'react';
import defaultStyles from 'src/components/Form/styles.default.module.css';
import { useFormContext } from 'src/form';

type Props = {
  name: string;
  label: string;
  placeholder: string;
};

export const InputPhone: FC<Props> = memo((props) => {
  const { ref, focused } = useFocusWithin();
  const form = useFormContext();
  const formProps = form.getInputProps(props.name);

  return (
    <TextInput
      ref={ref}
      inputMode="tel"
      type="number"
      classNames={{
        input: defaultStyles.input,
        label: defaultStyles.label,
        root: cx({
          [defaultStyles.root]: true,
          [defaultStyles.rootFocused]: focused,
        }),
      }}
      withAsterisk={false}
      {...props}
      {...formProps}
    />
  );
});
